<template>
    <div class="shop-checkout__button">
        <div class="button-wrapper--order-btn">
            <button @click="order" :disabled="isOrderingDisabled" :class="['button', 'button--primary']"><slot name="button-label" /></button>
            <p class="error" v-html="replacedErrorText" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "shop-checkout-button",
        props: {
			errortext: String,
			newsletteruri: String,
			newsletterlabel: String,
            orderItemCount: Number,
            showErrorMessage: {
			    type: Boolean,
                default: true
            },
            shopDisabled: {
			    type: Boolean,
			    default: false
            }
        },
		computed: {
			isOrderingDisabled () {
				return this.$store.getters.cartIsOrderingDisabled || this.orderItemCount > window.wishcart_orderMaxItems || this.shopDisabled;
			},
            replacedErrorText() {
                if(!window.shopenabled) {
                    return this.$t('shopDisabledMessage');
                }

			    if (!this.showErrorMessage) {
			        return '';
                }

			    let text = this.errortext;
			    if (!text && this.orderItemCount > window.wishcart_orderMaxItems) {
                    text = this.$t('checkout.errors.too_full');
                }

			    const max = window.wishcart_orderMaxItems;
			    const count = this.orderItemCount;
			    text = text.replace(/MAX/, max);
                text = text.replace(/COUNT/, count);
                text = text.replace(/DELTA/, count > max ? count - max : '');

			    return text;
            }
		},
        methods: {
            order() {
                if(!this.$store.getters.freeze) {
                    this.$emit('order');
                }
            }
        }
    }
</script>
